import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const moreRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (moreRef.current && !moreRef.current.contains(e.target as Node)) {
        setIsMoreOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="bg-white shadow-sm relative z-50">
      {/* Top Bar */}
      <div className="bg-gray-50 border-b">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-2">
            <div className="flex items-center space-x-4">
              <a href="tel:916-257-8244" className="text-sm text-gray-600 hover:text-emerald-600 flex items-center cursor-pointer">
                <i className="fa fa-phone mr-1"></i>
                <span className="hidden sm:inline">(916) 257-8244</span>
              </a>
            </div>
            <div className="flex items-center space-x-3">
              <a href="https://www.facebook.com/profile.php" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-600 hover:text-emerald-600 cursor-pointer">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://www.twitter.com/JeffL_eXpRealty" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-600 hover:text-emerald-600 cursor-pointer">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://www.linkedin.com/in/jeffery-long-355a73352/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-600 hover:text-emerald-600 cursor-pointer">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="https://www.youtube.com/@realestatedevelopmentautho3005" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-600 hover:text-emerald-600 cursor-pointer">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://www.instagram.com/jeffery_long_exp_realty0223443/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-600 hover:text-emerald-600 cursor-pointer">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center cursor-pointer">
              <div className="flex flex-col items-start">
                <img 
                  src="https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1727374637.png" 
                  alt="Jeffery Long - eXp Realty Logo" 
                  className="h-12 w-auto"
                />
                <div className="mt-1">
                  <span 
                    className="text-sm font-bold text-gray-800 tracking-wide"
                    style={{ fontFamily: '"Eurostile Extended", "Arial Black", sans-serif' }}
                  >
                    Real Estate Development Authority
                  </span>
                </div>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            <Link to="/" className="px-3 py-2 text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer">
              Home
            </Link>
            <a 
              href="https://joinapp.exprealty.com/" 
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="px-3 py-2 text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer"
            >
              Join My Team
            </a>
            <Link to="/agents" className="px-3 py-2 text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer">
              Agents
            </Link>
            <Link to="/sell" className="px-3 py-2 text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer">
              Sell
            </Link>
            <Link to="/finance" className="px-3 py-2 text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer">
              Finance
            </Link>
            <Link to="/contact" className="px-3 py-2 text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer">
              Contact
            </Link>
            <Link to="/faq" className="px-3 py-2 text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer">
              FAQ
            </Link>

            {/* More Dropdown */}
            <li ref={moreRef} className="relative list-none">
              <button 
                onClick={() => setIsMoreOpen(!isMoreOpen)}
                className="flex items-center px-3 py-2 text-gray-700 hover:text-emerald-600 transition-colors font-medium text-sm whitespace-nowrap cursor-pointer"
              >
                More
                <i className={`fa fa-chevron-down ml-1.5 text-[10px] transition-transform duration-200 ${isMoreOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isMoreOpen && (
                <ul className="absolute right-0 mt-2 w-56 bg-white shadow-xl rounded-lg border border-gray-100 py-2 z-50 animate-fade-in">
                  <li>
                    <a 
                      href="https://jefferylong.exprealty.com/index.php?showagent=1&rtype=map" 
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-search-line text-base"></i></span>
                      Home Search
                    </a>
                  </li>
                  <li>
                    <Link 
                      to="/blog" 
                      onClick={() => setIsMoreOpen(false)}
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-article-line text-base"></i></span>
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/resources" 
                      onClick={() => setIsMoreOpen(false)}
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-book-open-line text-base"></i></span>
                      Resources
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/toolkits" 
                      onClick={() => setIsMoreOpen(false)}
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-tools-line text-base"></i></span>
                      Toolkits
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/faq" 
                      onClick={() => setIsMoreOpen(false)}
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-question-answer-line text-base"></i></span>
                      FAQ
                    </Link>
                  </li>
                  <li className="border-t border-gray-100 my-1"></li>
                  <li>
                    <Link 
                      to="/backoffice" 
                      onClick={() => setIsMoreOpen(false)}
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-dashboard-line text-base"></i></span>
                      Backoffice
                    </Link>
                  </li>
                  <li>
                    <Link 
                      to="/az-tax-sales" 
                      onClick={() => setIsMoreOpen(false)}
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-auction-line text-base"></i></span>
                      AZ Tax Sales
                    </Link>
                  </li>
                  <li>
                    <a 
                      href="https://businessdevelopmentauthority.net/ca-tax-foreclosures"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      onClick={() => setIsMoreOpen(false)}
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-map-2-line text-base"></i></span>
                      CA Tax Foreclosures
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.join-exp.world" 
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-presentation-line text-base"></i></span>
                      Agent Presentation
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://jefferylong.exprealty.com/index.php?showagent=1#rslt" 
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-home-4-line text-base"></i></span>
                      My Listings
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://jefferylong.buildersupdate.com/" 
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-emerald-50 hover:text-emerald-600 transition-colors cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-building-2-line text-base"></i></span>
                      New Construction
                    </a>
                  </li>
                </ul>
              )}
            </li>

            <Link to="/booking" className="ml-3 px-5 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition-colors whitespace-nowrap font-medium text-sm cursor-pointer">
              Book Appointment
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            <span className="sr-only">Open menu</span>
            <div className="w-6 h-6 flex flex-col justify-center items-center">
              <span className={`block h-0.5 w-6 bg-current transform transition duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
              <span className={`block h-0.5 w-6 bg-current mt-1 transition duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-6 bg-current mt-1 transform transition duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className={`${isMenuOpen ? 'block' : 'hidden'} lg:hidden border-t py-4`}>
          <ul className="flex flex-col space-y-1">
            <li>
              <Link to="/" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2.5 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors font-medium cursor-pointer">
                Home
              </Link>
            </li>
            <li>
              <a href="https://joinapp.exprealty.com/" target="_blank" rel="noopener noreferrer nofollow" className="block px-4 py-2.5 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors font-medium cursor-pointer">
                Join My Team
              </a>
            </li>
            <li>
              <Link to="/agents" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2.5 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors font-medium cursor-pointer">
                Agents
              </Link>
            </li>
            <li>
              <Link to="/sell" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2.5 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors font-medium cursor-pointer">
                Sell
              </Link>
            </li>
            <li>
              <Link to="/finance" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2.5 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors font-medium cursor-pointer">
                Finance
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2.5 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors font-medium cursor-pointer">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/faq" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2.5 text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors font-medium cursor-pointer">
                FAQ
              </Link>
            </li>

            {/* Divider */}
            <li className="border-t border-gray-200 my-2"></li>
            <li className="px-4 py-1">
              <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">More</span>
            </li>

            <li>
              <a href="https://jefferylong.exprealty.com/index.php?showagent=1&rtype=map" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-search-line text-base"></i></span>
                Home Search
              </a>
            </li>
            <li>
              <Link to="/blog" onClick={() => setIsMenuOpen(false)} className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-article-line text-base"></i></span>
                Blog
              </Link>
            </li>
            <li>
              <Link to="/resources" onClick={() => setIsMenuOpen(false)} className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-book-open-line text-base"></i></span>
                Resources
              </Link>
            </li>
            <li>
              <Link to="/toolkits" onClick={() => setIsMenuOpen(false)} className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-tools-line text-base"></i></span>
                Toolkits
              </Link>
            </li>
            <li>
              <Link to="/faq" onClick={() => setIsMenuOpen(false)} className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-question-answer-line text-base"></i></span>
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/backoffice" onClick={() => setIsMenuOpen(false)} className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-dashboard-line text-base"></i></span>
                Backoffice
              </Link>
            </li>
            <li>
              <Link to="/az-tax-sales" onClick={() => setIsMenuOpen(false)} className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-auction-line text-base"></i></span>
                AZ Tax Sales
              </Link>
            </li>
            <li>
              <a
                href="https://businessdevelopmentauthority.net/ca-tax-foreclosures"
                target="_blank"
                rel="noopener noreferrer nofollow"
                onClick={() => setIsMenuOpen(false)}
                className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-map-2-line text-base"></i></span>
                CA Tax Foreclosures
              </a>
            </li>
            <li>
              <a href="https://www.join-exp.world" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-presentation-line text-base"></i></span>
                Agent Presentation
              </a>
            </li>
            <li>
              <a href="https://jefferylong.exprealty.com/index.php?showagent=1#rslt" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-home-4-line text-base"></i></span>
                My Listings
              </a>
            </li>
            <li>
              <a href="https://jefferylong.buildersupdate.com/" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center px-4 py-2.5 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-md transition-colors cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center mr-3"><i className="ri-building-2-line text-base"></i></span>
                New Construction
              </a>
            </li>

            {/* Divider */}
            <li className="border-t border-gray-200 my-2"></li>
            <li className="px-4">
              <Link to="/booking" onClick={() => setIsMenuOpen(false)} className="block text-center px-5 py-2.5 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition-colors whitespace-nowrap font-medium cursor-pointer">
                Book Appointment
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
